import { MenuItem } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ButtonAddNew } from '../../../../components/styled/global.style'
import { ACTION, DIRECTION, METHODS, MODAL_TITLE, MODAL_TYPE } from '../../../../utils/constants'
import { StyledMenu } from '../../TradeBlotter.style'

function MenuButton({ isUserBooking }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const MENU_ITEMS = useMemo(
    () => ({
      NEW_DEAL: 'New Deal',
      NEW_CLIENT_TRADE: 'New Client Trade',
      NEW_MARKET_TRADE: 'New Market Trade'
    }),
    []
  )

  const handleClickMenuButton = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickMenuItem = event => {
    const key = event.target.innerText

    const openPopup = ({ url, name, message }) => {
      const popup = window.open(
        url,
        name,
        'width=600,height=600,top=100,left=100,toolbar=no,menubar=no,scrollbars=no,resizable=no'
      )

      const checkPopupLoaded = setInterval(() => {
        if (popup.document && popup.document.readyState === 'complete') {
          clearInterval(checkPopupLoaded)
          popup.postMessage(message, window.origin)
        }
      }, 500)
    }

    const baseUrl = window.location.origin

    const configMap = {
      [MENU_ITEMS.NEW_DEAL]: {
        url: `${baseUrl}/deal`,
        name: 'Create Deal',
        message: {
          type: MODAL_TYPE.DEAL,
          title: MODAL_TITLE.NEW_DEAL,
          action: ACTION.CREATE,
          method: METHODS.POST
        }
      },
      [MENU_ITEMS.NEW_CLIENT_TRADE]: {
        url: `${baseUrl}/trade`,
        name: 'Create Client Trade',
        message: {
          type: MODAL_TYPE.TRADE,
          title: MODAL_TITLE.NEW_CLIENT_TRADE,
          action: ACTION.CREATE,
          method: METHODS.POST,
          data: { trade_type: 'Client', direction: DIRECTION.CLIENT }
        }
      },
      [MENU_ITEMS.NEW_MARKET_TRADE]: {
        url: `${baseUrl}/trade`,
        name: 'Create Trade Market Maker',
        message: {
          type: MODAL_TYPE.TRADE,
          title: MODAL_TITLE.NEW_MARKET_TRADE,
          action: ACTION.CREATE,
          method: METHODS.POST,
          data: { trade_type: 'Market', direction: DIRECTION.MARKET_MAKER }
        }
      }
    }

    const config = configMap[key]
    if (config) {
      openPopup(config)
    }

    setAnchorEl(null)
  }

  return (
    <>
      <ButtonAddNew
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        onClick={handleClickMenuButton}
        disabled={!isUserBooking()}
        endIcon={<KeyboardArrowDownIcon />}
      >
        New Trade
      </ButtonAddNew>
      <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose} backgroundcolor={'#39393C'}>
        <MenuItem onClick={handleClickMenuItem} disableRipple name={MENU_ITEMS.NEW_DEAL}>
          New Deal
        </MenuItem>
        <MenuItem onClick={handleClickMenuItem} disableRipple name={MENU_ITEMS.NEW_TRADE}>
          New Client Trade
        </MenuItem>
        <MenuItem onClick={handleClickMenuItem} disableRipple name={MENU_ITEMS.NEW_TRADE}>
          New Market Trade
        </MenuItem>
      </StyledMenu>
    </>
  )
}

export default MenuButton

MenuButton.propTypes = {
  isUserBooking: PropTypes.func
}
